import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard-overview__container--minimized"
}
const _hoisted_2 = {
  key: 1,
  class: "dashboard-overview__container"
}
const _hoisted_3 = { class: "dashboard-overview__inner" }
const _hoisted_4 = { class: "row justify-end" }
const _hoisted_5 = { class: "pack-fullscreen-button--exit" }
const _hoisted_6 = { class: "stats--container horizontal-container" }
const _hoisted_7 = {
  key: 0,
  class: "stats--container horizontal-container"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "action-block-skeleton"
}
const _hoisted_10 = { class: "stats-card__count count-to__counter" }
const _hoisted_11 = {
  key: 2,
  class: "action-block-skeleton"
}
const _hoisted_12 = { class: "stats-card__count count-to__counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_card = _resolveComponent("progress-card")!
  const _component_count_to = _resolveComponent("count-to")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.toggleable && _ctx.internalMizimized)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "toggle-dashboard__container",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDashboard(false)))
        }, [
          _createElementVNode("h6", null, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "t-icon" }, "d", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.minimizedLabel), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "minimal",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fullscreen.exit && _ctx.fullscreen.exit(...args)))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("span", null, null, -1),
                _createElementVNode("span", { class: "t-icon" }, "s", -1)
              ]))
            ], 512), [
              [_vShow, _ctx.fullscreen.isFullscreen.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "row",
              style: _normalizeStyle({transformOrigin: 'top left', transform: _ctx.fullscreen.isFullscreen.value ? 'scale(2)' : 'scale(1)', marginBottom: _ctx.fullscreen.isFullscreen.value ? '8.6rem' : '0'})
            }, [
              (!_ctx.state.orders || _ctx.state.orders > 0)
                ? (_openBlock(), _createBlock(_component_progress_card, {
                    key: 0,
                    class: "cursor-pointer",
                    count: _ctx.state.fulfilled_orders || 0,
                    max: _ctx.FULFILLMENT_TARGET,
                    label: "Daily fulfillment target",
                    type: "orders",
                    onClick: _ctx.toPacking
                  }, null, 8, ["count", "max", "onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.state.orders || _ctx.state.orders > 0)
                ? (_openBlock(), _createBlock(_component_count_to, {
                    key: 1,
                    class: "cursor-pointer",
                    value: _ctx.state.orders,
                    label: "Pending orders",
                    interpolate: _ctx.state.orders,
                    "min-duration": 300,
                    track: "",
                    onClick: _ctx.toPacking
                  }, {
                    append: _withCtx(() => _cache[5] || (_cache[5] = [])),
                    _: 1
                  }, 8, ["value", "interpolate", "onClick"]))
                : (_openBlock(), _createBlock(_component_count_to, {
                    key: 2,
                    value: 0,
                    "counter-style": "success",
                    label: "All orders fulfilled"
                  }, {
                    svg: _withCtx(({count}) => _cache[6] || (_cache[6] = [
                      _createElementVNode("g", { transform: "scale(.85)" }, [
                        _createElementVNode("path", { d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z" }),
                        _createElementVNode("polygon", { points: "14.4,18.7 10.1,15.6 8.9,17.2 14.7,21.4 23.3,11.3 21.7,10" })
                      ], -1)
                    ])),
                    _: 1
                  })),
              _createVNode(_component_count_to, {
                class: "cursor-pointer",
                value: _ctx.state.picking_orders || 0,
                label: "Orders picking",
                interpolate: _ctx.state.picking_orders,
                "min-duration": 300,
                track: "",
                onClick: _ctx.toPicking
              }, null, 8, ["value", "interpolate", "onClick"]),
              (!(_ctx.roles.includes('client') || _ctx.roles.includes('supplier')))
                ? (_openBlock(), _createBlock(_component_count_to, {
                    key: 3,
                    class: "cursor-pointer",
                    value: _ctx.state.source_orders,
                    label: "Supply deliveries",
                    interpolate: _ctx.state.orders,
                    "min-duration": 300,
                    track: "",
                    onClick: _ctx.toSupplyOrders
                  }, null, 8, ["value", "interpolate", "onClick"]))
                : _createCommentVNode("", true)
            ], 4)
          ]),
          (!(_ctx.roles.includes('client') || _ctx.roles.includes('supplier')))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.state.drafts === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_q_skeleton, { type: "rect" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_skeleton, { type: "text" }),
                            _createVNode(_component_q_skeleton, {
                              type: "text",
                              style: {"width":"50%"}
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: _normalizeClass(["stats-card drafts-card count-to__container", {cleared: _ctx.state.drafts < 1}]),
                        to: { name: 'IssueTracker', params: { view: 'drafts' } }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.state.drafts), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stats-card__title count-to__label" }, "Drafts to process", -1))
                        ]),
                        _: 1
                      }, 8, ["class"])),
                  (_ctx.state.issue_orders === null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_q_skeleton, { type: "rect" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_skeleton, { type: "text" }),
                            _createVNode(_component_q_skeleton, {
                              type: "text",
                              style: {"width":"50%"}
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 3,
                        class: _normalizeClass(["stats-card issues-card count-to__container", {cleared: _ctx.state.issue_orders < 1}]),
                        to: { name: 'IssueTracker', params: { view: 'issues' } }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.state.issue_orders), 1),
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stats-card__title count-to__label" }, "Issues to process", -1))
                        ]),
                        _: 1
                      }, 8, ["class"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "toggle-dashboard__container",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDashboard(true)))
        }, [
          _createElementVNode("h6", null, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "t-icon" }, "c", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.expandedLabel), 1)
          ])
        ])
      ]))
}